import React from 'react'
import { Link } from 'gatsby'
import Centered from 'shared/ui/Centered'
import Icon from 'shared/ui/Icon'
import Heading from 'shared/ui/Heading'
import { IconContent, IconContentText } from 'shared/ui/IconContent'
import { Hero, HeroPrimaryContent } from '../ui/Hero'
import { SlantBackground, SlantBackgroundImage } from '../ui/SlantBackground'

export default function Workshops() {
  return (
    <div className="spacing-giant">
      <Hero>
        <HeroPrimaryContent>
          <div>
            <Heading className="text-color-blue">Professional Workshops</Heading>
            <div className="text-large">React, JavaScript, and Node</div>
          </div>
          <p>
            We provide two and three day workshops for some of the largest brands in the world. If
            your company can't pay for training for the full team, consider one of our similarly
            structured public workshops
          </p>
        </HeroPrimaryContent>
      </Hero>

      <SlantBackground verticalOffset={-5} shallowSlant>
        <SlantBackgroundImage src="/images/react-gray-two.svg" />
      </SlantBackground>

      <Centered>
        <section className="offset-slant-background-image-left">
          <ul className="list-reset spacing-large">
            <IconContent as="li" className="spacing-small">
              <IconContentText as={Heading} size={3}>
                <Icon name="arrow-right" size={1.5} color="brightBlue" />
                <strong>Corporate Workshops</strong>
              </IconContentText>
              <p>
                Interested in getting your whole team trained? We offer two-day corporate workshop
                trainings in React and JavaScript/Node. We have a curriculum that works great but
                we're always open to input on how we can make adjustments for your team's needs. We
                als have core (fundamentals) and advanced curriculum.
              </p>
              <Link className="button button-light" to="/corporate-training">
                Corporate Workshops
              </Link>
            </IconContent>
            <IconContent as="li" className="spacing-small">
              <IconContentText as={Heading} size={3}>
                <Icon name="arrow-right" size={1.5} color="brightBlue" />
                <strong>Public Workshops</strong>
              </IconContentText>
              <p>
                We also offer our workshops to the public, just in case your company isn't able to
                send the whole group.
              </p>
              <Link className="button button-light" to="/public-workshops">
                Public Workshops
              </Link>
            </IconContent>
          </ul>
        </section>
      </Centered>
    </div>
  )
}
